export const itemConditions = {
  NEW: 'New',
  LIKENEW: 'Like New',
  GOOD: 'Good',
  FAIR: 'Fair',
  POOR: 'Poor',
};
